// extracted by mini-css-extract-plugin
export default {"teamArchive":"TeamArchive_teamArchive__fuSGs","name":"TeamArchive_name__ZQghT"};